import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  COUNTRY_CODE_CANADA,
  REGION_CODE_ALBERTA,
  REGION_CODE_ONTARIO,
  envIsCanada,
  envIsNormal,
  matchesRegion,
} from '@/constants/constants';
import BffApiService from '@/shared/bffApiService';
import { setDetectedRegion } from '@/store/actions/commonActions';
import { selectIsROC, selectLocale } from '@/store/selectors/commonSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { useBffRequest } from '@/hooks/useBffRequest';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';
import { RegionCheckResponse } from '@/models/region-check.model';

export function useRegionGate(): void {
  const dispatch = useDispatch();
  const { openModal } = useModal();
  const { request } = useBffRequest(BffApiService.regionCheck);
  const locale = useSelector(selectLocale);
  const isROC = useSelector(selectIsROC);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (!locale) {
      return;
    }

    if (!envIsCanada() && !isROC) {
      return;
    }

    request({
      successCallback: (data: RegionCheckResponse | null) => {
        if (!data) return;

        dispatch(setDetectedRegion(data));

        const { countryCode, regionCode } = data;
        if (!matchesRegion(countryCode, COUNTRY_CODE_CANADA)) return;
        if (!regionCode) return;

        if (envIsNormal() && matchesRegion(regionCode, REGION_CODE_ALBERTA) && !isAuthenticated) {
          openModal(MODALS.ALBERTA_MIGRATION_GATE);
        }

        if (envIsCanada() && !matchesRegion(regionCode, REGION_CODE_ONTARIO)) {
          openModal(MODALS.LOCATION_GATE);
        }
      },
    });
  }, [locale]);
}
